<template>
  <component
    :is="ticketState.disabled ? 'div' : 'a'"
    v-if="!ticketState.hidden"
    class="styled-button styled-button--with-icon styled-button--primary"
    :class="{
      'styled-button--disabled': ticketState.disabled,
    }"
    :href="ticketState.disabled ? false : href"
    :target="ticketState.disabled ? false : target"
  >
    <dpc-icon
      class="styled-button__icon"
      :icon="ticketState.icon"
      decorative
    ></dpc-icon>
    <a-label
      class="styled-button__text"
      :path="ticketState.labelPath"
      :is-visible="true"
    >
    </a-label>
  </component>
</template>

<script>
import { toRefs, computed } from 'vue';

const TICKET_STATES = {
  NONE: {
    hidden: true,
  },
  FREE: {
    icon: 'tickets',
    labelPath: 'ticket.states.FREE',
  },
  FREE_DISABLED: {
    icon: 'tickets',
    labelPath: 'ticket.states.FREE_DISABLED',
    disabled: true,
  },
  FOR_SALE: {
    icon: 'tickets',
    labelPath: 'ticket.states.FOR_SALE',
  },
  REGISTRATION: {
    icon: 'tickets',
    labelPath: 'ticket.states.REGISTRATION',
  },
  FOR_SALE_DISABLED: {
    icon: 'tickets',
    labelPath: 'ticket.states.FOR_SALE_DISABLED',
    disabled: true,
  },
  FOR_SALE_BOXOFFICE: {
    icon: 'tickets',
    labelPath: 'ticket.states.FOR_SALE_BOXOFFICE',
    disabled: true,
  },
  FOR_SALE_LEFTOVERS: {
    icon: 'tickets',
    labelPath: 'ticket.states.FOR_SALE_LEFTOVERS',
  },
  WAITING_LIST: {
    icon: 'waiting_list',
    labelPath: 'ticket.states.WAITING_LIST',
  },
  SOLD_OUT: {
    icon: 'tickets_sold_out',
    labelPath: 'ticket.states.SOLD_OUT',
    disabled: true,
  },
  CANCELLED: {
    icon: 'close',
    labelPath: 'ticket.states.CANCELLED',
    disabled: true,
  },
  LIVESTREAM: {
    icon: 'livestream',
    labelPath: 'ticket.states.LIVESTREAM',
  },
};
Object.freeze(TICKET_STATES);

export default {
  props: {
    state: {
      type: String,
      required: true,
      validator(value) {
        if (!Object.keys(TICKET_STATES).includes(value)) {
          throw new Error(
            `Invalid value for 'state': ${value}. Valid values: ${Object.keys(
              TICKET_STATES
            ).join(', ')}`
          );
        }
        return Object.keys(TICKET_STATES).includes(value);
      },
    },
    href: String,
    target: {
      type: String,
      default: '_self',
    },
  },
  setup(props) {
    const { state } = toRefs(props);

    const ticketState = computed(() => TICKET_STATES[state.value]);

    return {
      ticketState,
    };
  },
};
</script>
